<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'FEEDBACK_DIALOG.TITLE' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="content-content">
            <div class="content-description">
                {{ 'FEEDBACK_DIALOG.DESCRIPTION' | translate }}
            </div>
        </div>
        <div class="content-action">
            <form #feedbackForm="ngForm">
                <div class="default-form-field">
                    <mat-label>{{ 'FEEDBACK_DIALOG.SENDER_EMAIL_LABEL' | translate }}</mat-label>
                    <mat-form-field fxFlex class="feedback-email" appearance="outline">
                        <input
                            data-at-feedback-email
                            matInput
                            required
                            type="email"
                            name="email"
                            [email]="true"
                            [placeholder]="'FEEDBACK_DIALOG.SENDER_EMAIL_LABEL' | translate"
                            [(ngModel)]="emailValue"
                        />
                        <mat-error>
                            {{ 'FEEDBACK_DIALOG.EMAIL_VALIDATION_ERROR_MSG' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="default-form-field">
                    <mat-label>{{ 'FEEDBACK_DIALOG.SUBJECT_LABEL' | translate }}</mat-label>
                    <mat-form-field fxFlex class="feedback-subject" appearance="outline">
                        <input
                            data-at-feedback-subject
                            matInput
                            required
                            name="subject"
                            [(ngModel)]="subjectValue"
                            [placeholder]="'FEEDBACK_DIALOG.SUBJECT_LABEL' | translate"
                        />
                        <mat-error>
                            {{ 'FEEDBACK_DIALOG.SUBJECT_REQUIRED_ERROR_MSG' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="default-form-field">
                    <mat-label>{{ 'FEEDBACK_DIALOG.MESSAGE_LABEL' | translate }}</mat-label>
                    <mat-form-field fxFlex class="feedback-message" appearance="outline">
                        <textarea
                            data-at-feedback-message
                            matInput
                            required
                            name="message"
                            [placeholder]="'FEEDBACK_DIALOG.MESSAGE_LABEL' | translate"
                            [(ngModel)]="messageValue"
                            rows="4"
                        ></textarea>
                        <mat-error>
                            {{ 'FEEDBACK_DIALOG.MESSAGE_REQUIRED_ERROR_MSG' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close color="primary">
            {{ 'COMMON.DIALOG.CANCEL' | translate }}
        </button>
        <button mat-flat-button color="primary" (click)="sendFeedback()" [disabled]="feedbackForm.invalid || isLoading">
            <mat-icon>send</mat-icon>
            {{ 'COMMON.DIALOG.SEND' | translate }}
        </button>
    </mat-dialog-actions>
</div>
